<template>
    <div>
        <div class="header">
            <h3><i class="fa fa-bell"></i>待办任务</h3>
            <span>共有<b>{{notifyCount}}</b>个任务待处理</span>
        </div>
        <div class="content">
            <ul>
                <li @click="go(1)">待退款<b>{{creditCount}}</b>件</li>
                <li @click="go(2)">待退货<b>{{financeCount}}</b>件</li>
                <li @click="go(3)">待评价<b>{{evaluateAuditCount}}</b>条</li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TaskNofity',
        data () {
            return {
                notifyCount: 0,
                creditCount: 0,
                financeCount: 0,
                repayCount: 0,
                evaluateAuditCount:0,
            }
        },
        methods: {
            polling(){

                /*setInterval(() => {*/
                    if(this.$route.path.indexOf('login') > -1){
                        return;
                    }
                    this.request('order/orderRefundAuditNumber', {}, (res) => {
                        if (res.result == true) {
                            this.notifyCount = res.data.auditCount;
                            this.creditCount = res.data.refundOrderCount;
                            this.financeCount = res.data.salesReturnCount;
                            this.evaluateAuditCount= res.data.evaluateAuditCount
                            this.$emit('update', res.data.auditCount);
                        }
                    });
              /*  }, 5000)*/
            },
            go(type){
                if(type == 1){
                    router.push('/reimbursement/reimbursement');
                }
                else if(type == 2){
                    router.push('/salesReturn/salesReturn');
                }else if(type == 3){
                    router.push('/evaluate/evaluate');
                }
            },
            request(url, data, cb, errCb) {
                axios.post(url, data).then((res) => { 
                    if (res.data.status == 0) {
                        _g.toast('info', res.data.message)
                    }
                    else {
                        cb(res.data)
                    }
                }).catch((res) => {
                    _g.toast('error', res.message);
                })
            }
        },
        created(){
            this.polling()
        },
        watch:{
            $route(to,from){
                this.polling()
            }
        },
    }
</script>

<style scoped>

    .header {
        padding: 10px 10px 10px 20px;
        text-align: left;
        color: #555;
        background-color: #ececec;
        height: 63px;
    }

    .header h3 {
        margin: 0px;
        padding: 0px;
        line-height: 35px;
        font-size: 16px;
    }

    .header h3 i {
        font-weight: normal;
        margin-right: 5px;
        font-size: 15px;
    }

    .header span {
        color: #666;
        font-size: 15px;
    }

    .header span b {
        color: #1B84ED;
        margin: 0px 3px;
        font-size: 18px;
    }
    .content{

    }

    .content ul{
        padding: 0px;
        margin: 0px;
    }
    li{
        list-style: none;
        border-bottom: 1px solid #cccccc;
        padding: 15px 15px;
        cursor: pointer;
    }

    li:hover{
        background-color: #cccccc;
    }

    li b {
        color: #1B84ED;
        margin: 0px 3px;
        font-size: 18px;
    }
</style>
